import { Injectable, Signal, inject } from '@angular/core';

import { makeItemId } from '../functions/dashboard-chart.functions';
import type { ChartBuilderConfig } from '../types/chart-builder.type';
import { UserPreferencesService } from './user-preferences.service';

@Injectable({ providedIn: 'root' })
export class ChartBuilderConfigsService {
  private readonly prefs = inject(UserPreferencesService);

  readonly configs: Signal<ReadonlyArray<ChartBuilderConfig>> =
    this.prefs.select('chartBuilderConfigs');

  save(entry: Omit<ChartBuilderConfig, 'id'>): string {
    const id = makeItemId();
    const config: ChartBuilderConfig = { id, ...entry };
    this.prefs.set('chartBuilderConfigs', [...this.prefs.get('chartBuilderConfigs'), config]);
    return id;
  }

  update(id: string, entry: Omit<ChartBuilderConfig, 'id'>): void {
    this.prefs.set(
      'chartBuilderConfigs',
      this.prefs.get('chartBuilderConfigs').map((c) => (c.id === id ? { id, ...entry } : c)),
    );
  }

  delete(id: string): void {
    this.prefs.set(
      'chartBuilderConfigs',
      this.prefs.get('chartBuilderConfigs').filter((c) => c.id !== id),
    );
  }
}
